import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface Post {
  userId: number;
  id: number;
  title: string;
  completed: string;
}

export interface SortConfig {
  key: "userId" | "id" | "completed";
  order: "ASC" | "DESC";
}

interface PostsState {
  posts: Post[];
  sortConfig: SortConfig;
  loading: boolean;
  error: string | null;
}

const initialState: PostsState = {
  posts: [],
  sortConfig: { key: "id", order: "ASC" },
  loading: false,
  error: null,
};

const postsSlice = createSlice({
  name: "posts",
  initialState,
  reducers: {
    fetchPostsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchPostsSuccess: (state, action: PayloadAction<Post[]>) => {
      state.loading = false;
      state.posts = action.payload;
    },
    fetchPostsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },

    // 정렬 요청
    fetchSortedPostsRequest(state, action: PayloadAction<SortConfig>) {
      state.loading = true;
      state.sortConfig = action.payload;
    },
    fetchSortedPostsSuccess(state, action: PayloadAction<Post[]>) {
      state.loading = false;
      state.posts = action.payload;
    },
  },
});

export const {
  fetchPostsRequest,
  fetchPostsSuccess,
  fetchPostsFailure,
  fetchSortedPostsRequest,
  fetchSortedPostsSuccess,
} = postsSlice.actions;

export default postsSlice.reducer;
